import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Score } from './Score';

export const Status = types.compose(
  BaseEntity,
  types
    .model('Status', {
      running: types.boolean,
      terminatedEarly: types.boolean,
      currentBestScore: types.optional(Score, {}),
      firstDD: types.string,
      startDD: types.string,
      lastDD: types.string,
      startedOn: types.string,
      runId: types.number,
      duration: types.number,
      solutionCount: types.number
    })
    .actions((self) => {
      // const setCurrentBestScore = (score: typeof Score) => {
      //   self.currentBestScore = score;
      // };
      const setRunning = (running: boolean) => {
        self.running = running;
      };
      const setTerminatedEarly = (terminatedEarly: boolean) => {
        self.terminatedEarly = terminatedEarly;
      };
      return {
        // setCurrentBestScore,
        setRunning,
        setTerminatedEarly,
      };
    }),
);
